import { useEffect, useRef, useState } from "react";
import Upiimg from '../assets/images/upipng.png'
import Net from '../assets/images/netBankingpng.png'
import Qr from '../assets/images/qur.png'
import TetherImg from '../assets/images/Tether.png';
import { Link, useNavigate, useLocation } from "react-router-dom";
import AuthService from "../services/auth.service";
import Loader from "../components/loader";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../app/store";
import { showToast } from "../app/slice/toastsSlice";

interface LocationState {
    id: number;
    amount: number;
    type: string;
    list: any;
}

function DepositPayment() {

    // Default selected option and image
    let fileInputRef = useRef<HTMLInputElement>(null);
    const [selectedOption, setSelectedOption] = useState<any>();
    const [selectedImage, setSelectedImage] = useState<string>(Upiimg);
    const [isPageloading, setIsPageLoading] = useState(true);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [gatewayDetails, setGatewaysDetails] = useState<any>("");
    // const [depositData, setDepositData] = useState<any>();
    const [previewImage, setPreviewImage] = useState<string>("");
    const [txnId, setTxnId] = useState<any>("");
    const [imageFile, setImageFile] = useState<File>();
    const location = useLocation();
    const state = location.state as LocationState | undefined;
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();

    // This effect is used to set the default values when the component mounts
    useEffect(() => {
        if (state) {
            setSelectedOption(state?.type);
            //setDepositData(state?.list);
            setSelectedOption(state?.list.find((item: any) => item.slug === state?.type));
            getGateway();

        } else {
            navigate(-1);
        }

    }, [state]);


    const handleSelectOption = (e: any, value: any) => {
        e.preventDefault();
        navigate(location.pathname, {
            replace: true, // This prevents adding a new entry in the history stack
            state: { id: value?.id, amount: state?.amount, type: value?.slug, list: state?.list }, // The state you want to pass
        });

    };


    function getGateway() {
        setIsPageLoading(true);
        var formData = {
            amount: state?.amount,
            gateway: state?.id
        }

        AuthService.gateway(formData)
            .then(
                (response) => {
                    // console.log(response.data);
                    if (response.status === 200) {
                        setGatewaysDetails(response.data)
                    }
                }
            ).catch((error) => {
                //console.log(error?.status, error?.response?.data?.status)
                const message = error?.response?.data?.error_description;
                setMessage(message);

                if (error?.response?.data?.status === 401) {
                    localStorage.removeItem("w_token");
                    navigate('/login');
                }
            }).finally(() => {
                setIsPageLoading(false);
            });
    }


    const onChangeHandle = (e: any) => {
        setMessage('');
        setTxnId(e.target.value);
    };

    const handleSetImage = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFile = e.target.files as FileList;
        if (selectedFile?.[0]) {
            setImageFile(selectedFile?.[0]);
            setPreviewImage(URL.createObjectURL(selectedFile?.[0]));
            setMessage('');
        }
    }

    const removeImage = () => {
        setImageFile(undefined);
        setPreviewImage("");

        if (fileInputRef.current) {
            fileInputRef.current.value = ''; // Clearing the value
        }
    };

    const handleTransactionSubmit = (e: any) => {
        if (loading) return;
        e.preventDefault();
        setMessage('');
        setLoading(true);

        const form = document.getElementById('txn_form') as HTMLFormElement;
        const formData = new FormData(form);

        if (!imageFile && !txnId) {
            setMessage('Please enter UTR number or upload transaction screenshot.');
            setLoading(false);
            return false;
        }

        formData.append('amount', String(state?.amount));
        formData.append('gateway', String(state?.id));
        formData.append('gateway_name', String(state?.type));
        formData.append('adminId', String(gatewayDetails?.adminId));

        AuthService.deposite(formData).then(
            (response) => {
                if (response.status === 200) {
                    setMessage(response.message);
                    setTimeout(() => {
                        navigate("/deposit", {
                            replace: true,
                            state: {},
                        });
                    }, 1000);
                    let toast = {
                        type: 'success',
                        title: 'Success',
                        message: response.message
                    }
                    dispatch(showToast(toast));

                } else {
                    setMessage(response.message);
                    let toast = {
                        type: 'error',
                        title: 'Error',
                        message: response.message
                    }
                    dispatch(showToast(toast));
                }
            }
        ).catch((error: any) => {
            const message = error?.response?.data?.error_description;
            setMessage(message);

            if (error?.response?.data?.status === 401) {
                localStorage.removeItem("w_token");
                navigate('/login');
            }
        }).finally(() => {
            setLoading(false);
        });

    };


    const handleCopy = async (id: any) => {
        const inputValue = document.getElementById(id) as HTMLInputElement;

        if ("clipboard" in navigator) {
            await navigator.clipboard.writeText(inputValue.value);
        } else {
            inputValue.select();
            inputValue.setSelectionRange(0, 99999);
            document.execCommand("copy");
        }

        let toast = {
            type: 'success',
            title: 'Copied!',
            //message: 'Copied'
        }
        dispatch(showToast(toast));
    };

    return (
        <>
            {isPageloading && <Loader />}
            <section className="BanlScreen">
                {/* <div className="container">
                    <div className="row">
                        <div className="col-12 p-0">
                            <button className="backPayment" onClick={goBack}>
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 42 42" fill="none">
                                        <path d="M18.9497 21.0012L27.6119 29.6632L25.137 32.138L14 21.0012L25.137 9.86426L27.6119 12.3391L18.9497 21.0012Z" fill="white" />
                                    </svg>
                                </span>
                                Back
                            </button>
                        </div>
                    </div>
                </div> */}
                <div className="container upiScreen">
                    <div className="row upiScreenSelectedMethod depositWe">
                        {/* <div className='depWithdrawal p-0'>
                            <Link to="/deposit">
                                <button className='active'>Deposit</button>
                            </Link>
                            <Link to="/Withdrawal">
                                <button>Withdrawal</button>
                            </Link>
                        </div> */}
                        <label className="dropdownLabel p-0">Selected Method</label>
                        <div className="dropdown p-0">
                            {/* Button with the selected option and image */}
                            <button
                                className="btn btn-primary dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                {selectedOption?.icon && (
                                    <img
                                        src={selectedOption?.icon}
                                        alt="Selected Option"
                                        style={{ width: 20, height: 20, marginRight: '8px' }}
                                    />
                                )}
                                {selectedOption?.name}

                            </button>
                            <ul className="dropdown-menu">
                                {state?.list?.length > 0 && state?.list?.map((key: any, index: number) => (
                                    <li onClick={(e: any) => handleSelectOption(e, key)} key={index}>
                                        <a className="dropdown-item" href="#">
                                            <img
                                                src={key?.icon}
                                                alt="Option 1"
                                                className="me-2"
                                                style={{ width: 20, height: 20 }}
                                            />
                                            {key?.name}
                                        </a>
                                    </li>
                                ))}

                            </ul>
                        </div>
                        {/* {selectedOption === 'option1' && (
                       <p></p>
                    )}

                    {selectedOption === 'option2' && (
                        <p></p>
                    )}

                    {selectedOption === 'option3' && (
                        <p></p>
                    )}
                    {selectedOption === 'option4' && (
                        <p></p>
                    )} */}

                    </div>
                    <div className="row">
                        {/* <div className="col-12">
                        <div className="d-flex align-items-center justify-content-center">
                            <p className="payheding">Amount Payable</p>
                            <h1 className="payAmout">₹100</h1>
                        </div>
                        <p className="depositDetal">Kindly  Deposit your amount on the given Bank details :</p>
                    </div> */}
                        <div className="col-12 mt-2 bankDetal">

                            <div className="row">
                                <div className="col-12 my-mb">
                                    <label className="mt-0" htmlFor="amount">Amount Payable</label>
                                    <div className="inputBank">
                                        <input className="trxId" id="amount" type="text" value={state?.amount} readOnly />
                                        <button onClick={() => handleCopy("amount")}>
                                            <svg height="20" viewBox="0 0 24 24" width="24" fill="#94A3B8" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M14 8H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2z" />
                                                <path d="M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                {gatewayDetails?.type === 'bank' &&
                                    <>
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 my-mb">
                                            <label htmlFor="acc_holder_name">Account Holder Name</label>
                                            <div className="inputBank">
                                                <input className="trxId" id="acc_holder_name" type="text" value={gatewayDetails?.account_holder_name} readOnly />
                                                <button onClick={() => handleCopy("acc_holder_name")}>
                                                    <svg height="20" viewBox="0 0 24 24" width="24" fill="#94A3B8" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M14 8H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2z" />
                                                        <path d="M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 my-mb">
                                            <label htmlFor="acc_number">Account Number</label>
                                            <div className="inputBank">
                                                <input className="trxId" id="acc_number" type="text" value={gatewayDetails?.account_number} style={{ letterSpacing: '1px' }} readOnly />
                                                <button onClick={() => handleCopy("acc_number")}>
                                                    <svg height="20" viewBox="0 0 24 24" width="24" fill="#94A3B8" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M14 8H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2z" />
                                                        <path d="M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 my-mb">
                                            <label htmlFor="ifsc_code">IFSC Code</label>
                                            <div className="inputBank">
                                                <input className="trxId" id="ifsc_code" type="text" value={gatewayDetails?.ifsc_code} style={{ letterSpacing: '1px' }} readOnly />
                                                <button onClick={() => handleCopy("ifsc_code")}>
                                                    <svg height="20" viewBox="0 0 24 24" width="24" fill="#94A3B8" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M14 8H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2z" />
                                                        <path d="M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 my-mb">
                                            <label htmlFor="bank_name">Bank Name</label>
                                            <div className="inputBank">
                                                <input className="trxId" id="bank_name" type="text" value={gatewayDetails?.bank_name} readOnly />
                                                <button onClick={() => handleCopy("bank_name")}>
                                                    <svg height="20" viewBox="0 0 24 24" width="24" fill="#94A3B8" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M14 8H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2z" />
                                                        <path d="M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                }

                                {gatewayDetails?.type === 'image' &&
                                    <div className="col-12">
                                        <p className="depositDetal text-center fw-bold" style={{ color: '#ccc' }}>Scan Qr To Pay</p>
                                        <div className="qrPayment">
                                            <img src={gatewayDetails?.details} alt="" className="img-fluid" />
                                        </div>
                                    </div>
                                }

                                {gatewayDetails?.type === 'text' &&
                                    <>
                                        <div className="col-x-6 col-lg-6 col-md-6 col-sm-12 col-12 my-mb">
                                            <label htmlFor="upi_name">Name</label>
                                            <div className="inputBank">
                                                <input className="trxId m-0 p-0" id="upi_name" type="text" value={gatewayDetails?.name} readOnly />
                                                <button style={{ width: 'auto', margin: 0, padding: 0 }} onClick={() => handleCopy("upi_name")}>
                                                    <svg height="20" viewBox="0 0 24 24" width="24" fill="#94A3B8" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M14 8H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2z" />
                                                        <path d="M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-x-6 col-lg-6 col-md-6 col-sm-12 col-12 my-mb">
                                            <label htmlFor="upi_id">UPI Id </label>
                                            <div className="inputBank">
                                                <input className="trxId m-0 p-0" id="upi_id" type="text" value={gatewayDetails?.details} readOnly />
                                                <button style={{ width: 'auto', margin: 0, padding: 0 }} onClick={() => handleCopy("upi_id")}>
                                                    <svg height="20" viewBox="0 0 24 24" width="24" fill="#94A3B8" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M14 8H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2z" />
                                                        <path d="M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                }

                                {gatewayDetails?.length === 0 &&
                                    <div className="col-12 my-mb">
                                        <div className="inputBank d-block">
                                            <p className="text-danger text-center mt-2">Currently No Gateway Available!! Please try again later.</p>
                                        </div>
                                    </div>
                                }
                            </div>


                            <div className="col-12 screenShotSec p-0 my-mb">
                                <form id="txn_form" onSubmit={handleTransactionSubmit}>
                                    <label htmlFor="txn_id">Submit UTR Manually <sup style={{ color: '#F75653' }}>*</sup></label>
                                    <input className="trxId" type="text" id="txn_id" name="txn_id" value={txnId} placeholder='Enter UTR (12 digit UPI Request)' onChange={onChangeHandle} autoComplete="off" maxLength={12} />
                                    <label className="mt-3">Upload Transaction Screenshot <sup style={{ color: '#F75653' }}>*</sup></label>
                                    <div className="uplodScreenBtn">
                                        {previewImage ? (
                                            <>
                                                <div className="uplodPrview">
                                                    <button onClick={removeImage}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="19" viewBox="0 0 21 19" fill="none">
                                                            <path d="M15.6203 5.1817L5.83838 14.09M5.83838 5.1817L15.6203 14.09" stroke="#fff" strokeWidth="1.63033" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </button>
                                                    <img className="preview" src={previewImage} alt="" width='85px' height="73px" />
                                                </div>
                                            </>
                                        ) :
                                            (<svg className="uplodWeb" width="80" height="70" viewBox="0 0 90 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="89.8876" height="80" rx="3.59551" fill="#314A55" fillOpacity="0.78" />
                                                <rect x="0.449438" y="0.449438" width="88.9888" height="79.1011" rx="3.14607" stroke="#F8F8F8" strokeOpacity="0.1" strokeWidth="0.898876" strokeDasharray="3.8 3.8" />
                                                <g opacity="0.2">
                                                    <path d="M66.6693 13.7528H23.3337C19.8406 13.7528 17 16.5924 17 20.0897V59.9177C17 63.4108 19.8406 66.2475 23.3337 66.2475H66.6691C70.1622 66.2475 72.9998 63.4108 72.9998 59.9177V20.0897C73 16.5924 70.1624 13.7528 66.6693 13.7528ZM53.2124 23.177C56.5905 23.177 59.33 25.9167 59.33 29.2945C59.33 32.6724 56.5903 35.4121 53.2124 35.4121C49.8335 35.4121 47.0949 32.6724 47.0949 29.2945C47.0949 25.9167 49.8335 23.177 53.2124 23.177ZM64.683 60.3927H26.1929C24.5033 60.3927 23.7508 59.1703 24.5125 57.6622L35.0114 36.8672C35.7721 35.3593 37.2219 35.2247 38.2486 36.5663L48.8056 50.3626C49.8323 51.7045 51.6269 51.8186 52.8147 50.6165L55.3973 48.0012C56.5841 46.799 58.3327 46.9479 59.3013 48.3315L65.989 57.8843C66.9557 59.27 66.3725 60.3927 64.683 60.3927Z" fill="white" />
                                                </g>
                                            </svg>
                                            )}

                                        <div className="ms-3">
                                            <h6>
                                                <svg className="me-2" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                                    <g clipPath="url(#clip0_683_5092)">
                                                        <path d="M13.9899 13.9899L10.4924 10.4924L6.99496 13.9899" stroke="white" strokeWidth="1.00889" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M10.4922 10.4924V18.3618" stroke="white" strokeWidth="1.00889" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M17.8284 16.0796C18.6812 15.6147 19.3549 14.879 19.7431 13.9887C20.1314 13.0984 20.2121 12.1041 19.9725 11.1628C19.7329 10.2215 19.1867 9.38679 18.42 8.79041C17.6534 8.19404 16.7099 7.86995 15.7386 7.86931H14.6369C14.3722 6.84564 13.879 5.89528 13.1942 5.08969C12.5093 4.28409 11.6508 3.64423 10.6831 3.2182C9.71539 2.79217 8.6637 2.59106 7.60708 2.62999C6.55046 2.66892 5.51642 2.94687 4.58269 3.44296C3.64896 3.93905 2.83984 4.64036 2.21616 5.49416C1.59248 6.34796 1.17048 7.33204 0.981866 8.37242C0.793256 9.41279 0.842951 10.4824 1.12722 11.5008C1.41148 12.5192 1.92292 13.4599 2.62308 14.2522" stroke="white" strokeWidth="1.00889" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M13.9899 13.9899L10.4924 10.4924L6.99496 13.9899" stroke="white" strokeWidth="1.00889" strokeLinecap="round" strokeLinejoin="round" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_683_5092">
                                                            <rect width="20.9849" height="20.9849" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                Select and Uplaod files
                                            </h6>
                                            <p>Supported formates: JPEG, PNG, JPEG, PDF</p>
                                        </div>
                                        <input type="file" id="transaction_image" name="image" accept="image/*" ref={fileInputRef} onChange={e => handleSetImage(e)} style={{ opacity: '0' }} />

                                    </div>
                                    {message && (
                                        <div className='d-block text-danger mb-2 text-center' role="alert">
                                            <small>{message}</small>
                                        </div>
                                    )}
                                    <button type="submit" disabled={loading || gatewayDetails?.length === 0} >
                                        {loading ?
                                            <>
                                                <span className="spinner-border spinner-border-sm me-1" role="status"></span>Please wait...
                                            </>
                                            :
                                            <>DEPOSIT</>
                                        }
                                    </button>
                                </form>
                            </div>
                            <div className="col-12 mt-2">
                                <h3 className="text-white mt-2">Quick Guide 🔥 </h3>
                                <p style={{ fontSize: 12, color: '#ccc', opacity: '0.7' }}>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                </p>
                            </div>
                        </div>


                    </div>
                </div>
            </section>
        </>
    )
}
export default DepositPayment;